import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useGlobalStoreData } from '../store/globalStore'

const withAuth = (Component) => (props) => {
  const isLoggedInGSD = useGlobalStoreData.isLoggedIn()
  const languageGSD = useGlobalStoreData.language()
  const location = useLocation()

  const redirectPath = `${process.env.PUBLIC_URL}/${languageGSD}/login`

  return isLoggedInGSD
    ? (
    <Component {...props} />
      )
    : (
    <Navigate
      to={redirectPath}
      replace
      state={{
        from: {
          pathname: location.pathname,
          search: location.search
        },
        sessionExpired: true
      }}
    />
      )
}

export default withAuth
